import enUS from "./enUS"
import esMX from "./esMX"

const lang = { enUS, esMX }

export default lang
